export interface IState {
    id: number,
    description: string,
    abbreviation: string,
    countryId: number,
    countryName: string
}